import { __assign, __awaiter, __generator } from "tslib";
import DeviceManagerService from '../device-manager/device-manager-service';
import { playbackService as playbackServiceSingleton, modifyCapabilities, } from '../playback/playback-service';
import { ovpTokenService } from './ovp';
import { config, authenticationHandler } from './playback-config-storage';
var playbackService;
var deviceManagerService;
export function getPlaybackService() {
    if (playbackService) {
        return playbackService;
    }
    var signedRequest = authenticationHandler.signedRequest;
    playbackService = playbackServiceSingleton.createInstance({
        getRequestOptions: modifyCapabilities,
        ovpTokenService: ovpTokenService,
        request: signedRequest,
    });
    return playbackService;
}
export function getDeviceManagerService() {
    if (deviceManagerService) {
        return deviceManagerService;
    }
    var endpoints = config.endpoints, timeouts = config.timeouts;
    var signedRequest = authenticationHandler.signedRequest;
    deviceManagerService = DeviceManagerService.createInstance(config.ovpHeaders, {
        endpoints: {
            dcm: {
                hostname: endpoints.ovpHostname,
            },
        },
        request: signedRequest,
        ovpTokenService: ovpTokenService,
        timeouts: timeouts,
    });
    return deviceManagerService;
}
function modifyResponse(response) {
    return {
        ovpData: response.body,
        statusCode: response.status,
    };
}
function getAssetByContentId(playbackServiceFunction, ovpOptions, capabilities, contentId, serviceKey) {
    return playbackServiceFunction(Object.assign({}, ovpOptions, {
        capabilities: capabilities,
        contentId: contentId,
        coppaApplies: overrideOVPCoppa(ovpOptions.coppaApplies),
        hdcpEnabled: ovpOptions.hdcpEnabled,
        parentalControlPin: ovpOptions.parentalControlPin || '',
        personaParentalControlRating: getMaturityRating(),
        serviceKey: serviceKey,
    })).then(modifyResponse);
}
export function getLiveContent(serviceKey, ovpOptions) {
    return getAssetByContentId(getPlaybackService().getLiveContent, ovpOptions, config.capabilities, undefined, serviceKey);
}
export function getEventAsset(contentId, ovpOptions) {
    return getAssetByContentId(getPlaybackService().getEventAsset, ovpOptions, config.capabilities, contentId);
}
export function getVODAsset(contentId, ovpOptions) {
    return getAssetByContentId(getPlaybackService().getVODAsset, ovpOptions, config.capabilities, contentId);
}
export function getPreviewAsset(contentId, ovpOptions) {
    return getAssetByContentId(getPlaybackService().getShortFormAsset, ovpOptions, config.capabilities, contentId);
}
export var exchangePrefetchToken = function (prePlayoutId, metadataToken, streamSourceType, ovpOptions) { return __awaiter(void 0, void 0, void 0, function () {
    var newHbInfo;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getDeviceManagerService().consolidatedStartStreamPrefetch(prePlayoutId, metadataToken, streamSourceType, ovpOptions)];
            case 1:
                newHbInfo = _a.sent();
                return [2 /*return*/, {
                        id: newHbInfo.id,
                        url: newHbInfo.heartbeat.url,
                        allowedMissed: newHbInfo.heartbeat.allowedMissed,
                        frequencyMs: newHbInfo.heartbeat.periodInMillis,
                    }];
        }
    });
}); };
export function decorateLicenseRequest(licenseRequest) {
    return authenticationHandler.applySignature(licenseRequest);
}
export var sendHeartbeat = function (url, streamPosition, ovpOptions) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, getPlaybackService().sendHeartbeat(__assign({ url: url, streamPosition: streamPosition }, ovpOptions))];
    });
}); };
export var stopHeartbeat = function (url, streamPosition, ovpOptions) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, getPlaybackService().stopStream(__assign({ url: url, streamPosition: streamPosition }, ovpOptions))];
    });
}); };
function overrideOVPCoppa(coppaApplies) {
    var _a;
    var personaSegments = (_a = config.getActiveProfile()) === null || _a === void 0 ? void 0 : _a.personaSegments;
    if (!personaSegments) {
        return coppaApplies;
    }
    for (var i = 0, length_1 = personaSegments.length; i < length_1; i++) {
        if (personaSegments[i] === "KIDS" /* PersonaSegment.KIDS */ || personaSegments[i] === "TEEN" /* PersonaSegment.TEEN */) {
            return true;
        }
    }
    return coppaApplies;
}
function getMaturityRating() {
    var _a, _b;
    return (_b = (_a = config.getActiveProfile()) === null || _a === void 0 ? void 0 : _a.controls) === null || _b === void 0 ? void 0 : _b.maturityRating;
}
//# sourceMappingURL=playback.js.map